import React from 'react';
import styled from 'styled-components';

const Title = styled.div`
  font-weight: 600;
  line-height: 19px;
  font-size: 16px;
  color: #41526A;
`;

export default Title;
